import OrderList from "../components/order/OrderList";
import { useState, useEffect, useContext } from "react";
import useAxios from "../services/useAxios";
import Tabs from "../components/tab/Tabs";
import { NavLink } from "react-router-dom";
import CustomButton from "../components/kits/button/CustomButton";
import Helmet from "react-helmet";
import { searchFunc } from "../utils/helperFunction";
import SearchInputContext from "../Search/SearchInput";
import AuthenticationContext from "../Authentication/AuthenticationContext.ts";

export default function OrderPage() {
  const { loading, execute } = useAxios("api2/orders_list");
  const [orderData, setOrderData] = useState([]);
  const [baseOrderData, setBaseOrderData] = useState([]);
  const [orderDataBuy, setOrderDataBuy] = useState([]);
  const [baseOrderDataBuy, setBaseOrderDataBuy] = useState([]);
  const [update, setUpdate] = useState(false);
  const [nav, setNav] = useState([]);
  const [tabContent, setTabContent] = useState([]);
  const { searchInput } = useContext(SearchInputContext);
  const { userInfo } = useContext(AuthenticationContext);

  useEffect(() => {
    execute().then((result) => {
      let temp = [];
      temp = result.orders.map((value) => {
        return {
          ...value,
          order_items: value.order_items.map((val) => {
            return {
              ...val,
              OptionOrderItem:
                val.OptionOrderItem.length > 0
                  ? JSON.parse(val.OptionOrderItem)
                  : [],
            };
          }),
        };
      });
      setOrderData(temp.filter((v) => v.type == 2).reverse());
      setBaseOrderData(temp.filter((v) => v.type == 2).reverse());
      setOrderDataBuy(temp.filter((v) => v.type == 1).reverse());
      setBaseOrderDataBuy(temp.filter((v) => v.type == 1).reverse());
    });
  }, [update]);
  useEffect(() => {
    setNav([
      { title: "سفارشات(فروش)", target: "#order-sell" },
      { title: " سفارش(خرید)", target: "#order-buy" },
    ]);
    setTabContent([
      {
        id: "order-sell",
        component: (
          <div className="col-12 ">
            <OrderList orderDataList={orderData} setUpdate={setUpdate} />
          </div>
        ),
      },
      {
        id: "order-buy",
        component: (
          <div className="col-12 ">
            <OrderList
              orderDataList={orderDataBuy}
              setUpdate={setUpdate}
              type="buy"
            />
          </div>
        ),
      },
    ]);
  }, [orderData]);
  useEffect(() => {
    let temp = searchFunc(
      searchInput,
      baseOrderData.map((value) => {
        let tempItems = {};
        value?.order_items?.map((v, i) => {
          tempItems = { ...tempItems, [`title-${i}`]: v.title };
          return v.title;
        });

        return {
          ...value,
          customer_name_search: `${value.customer?.firstname} ${value.customer?.lastname}`,
          company_name_search: value?.customer?.company_name,
          main_uid_search: `${value.customer?.main_uid?.fname} ${value.customer?.main_uid?.lname}`,
          ...tempItems,
        };
      })
    );
    setOrderData(temp);
    let tempBuy = searchFunc(
      searchInput,
      baseOrderDataBuy.map((value) => {
        return {
          ...value,
          customer_name_search: `${value.customer?.firstname} ${value.customer?.lastname}`,
          company_name_search: value?.customer?.company_name,
          main_uid_search: `${value.customer?.main_uid?.fname} ${value.customer?.main_uid?.lname}`,
        };
      })
    );
    setOrderDataBuy(tempBuy);
  }, [searchInput]);

  return (
    <div>
      <Helmet>
        <title>لیست سفارشات</title>
      </Helmet>
      {userInfo.userRoll.includes(16) && (
        <div className="d-flex">
          <NavLink
            to="/order/create"
            // target="_blank"
            style={{ textDecoration: "none" }}
          >
            {" "}
            <CustomButton size="medium" color="success" className="ms-3">
              افزودن سفارش
            </CustomButton>
          </NavLink>
        </div>
      )}
      {userInfo.userRoll.includes(15) && (
        <Tabs navItem={nav} tabContent={tabContent} type="horiz" />
      )}
    </div>
  );
}
